import React, { useRef, useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import FormGroup from '@mui/material/FormGroup';
import QlikIcon from '../../assets/qlik-icon.png'
import SnowflakeIcon from '../../assets/snowflake-icon.png'
import JedoxIcon from '../../assets/jedox-icon.png'
import TCIcon from '../../assets/taholaconnect-icon.png'
import QalyptusIcon from '../../assets/qalyptus-icon.png'
import AndroidSwitch from "../AndroidSwitch/AndroidSwitch";

const UpdateUsersAccess = (props) => {
    const { onSwitchToggle, tickboxFunc, qlikLicenceFunc, cardData, ...others } = props;
    // const initialSwitchesState = {
    //     "Tahola-AI Analytics": false,
    //     "Tahola-AI Reports": false,
    //     "TaholaConnect": false,
    //     "Tahola-AI Data Warehouse": false,
    //     "Jedox": false
    // }

    const initialSwitchesState = cardData.reduce((acc, app) => {
        acc[app.name] = false;
        return acc;
    }, {});

    // State to manage multiple switch toggles at app level
    const [expandedSwitches, setExpandedSwitches] = useState(initialSwitchesState);

    // We want to bring in the results of getUsersApps that is called when a user lands on the homepage.
    // const apps = [
    //     { name: 'Tahola-AI Reports', url: 'https://tahola.qalyptus.net/hub', imagepath: 'QalyptusIcon', imagealttext: 'Qalyptus Alt Text' },
    //     { name: 'TaholaConnect', url: 'https://taholaconnect.projectnovus.co.uk/', imagepath: 'TCIcon', imagealttext: 'TC alt text' },
    //     { name: 'Tahola-AI Analytics', url: 'https://taholacloud.eu.qlikcloud.com/', imagepath: 'QlikIcon', imagealttext: 'Qlik Alt Text' },
    //     { name: 'Tahola-AI Data Warehouse', url: 'https://sp65144.eu-west-2.aws.snowflakecomputing.com/', imagepath: 'SnowflakeIcon', imagealttext: 'Snowflake Alt Text' },
    //     { name: 'Jedox', url: 'https://www.jedox.com', imagepath: 'JedoxIcon', imagealttext: 'Jedox Alt Text' },
    // ]
    const apps = cardData;

    const handleToggle = (name) => {
        setExpandedSwitches((prev) => {
            const updatedState = {
                ...prev,
                [name]: !prev[name],
            };

            if (onSwitchToggle) {
                onSwitchToggle(name, updatedState[name]);
            }

            return updatedState;
        });
    };

    const handleQlikLicenceChange = (state) => {
        qlikLicenceFunc(state); // Pass the updated state up to NewUserInput
    };

    const renderList = apps.map((dataObj, index) => {
        // Determine the icon based on imagepath
        const icon =
            dataObj.imagepath === 'QlikIcon'
                ? QlikIcon
                : dataObj.imagepath === 'SnowflakeIcon'
                    ? SnowflakeIcon
                    : dataObj.imagepath === 'JedoxIcon'
                        ? JedoxIcon
                        : dataObj.imagepath === 'TCIcon'
                            ? TCIcon
                            : dataObj.imagepath === 'QalyptusIcon'
                                ? QalyptusIcon
                                : null;

        return (
            <div key={index}>
                <FormGroup>
                    <AndroidSwitch
                        labelObj={dataObj}
                        icon={icon}
                        checked={expandedSwitches[dataObj.name] || false}
                        onChange={() => handleToggle(dataObj.name)} />
                </FormGroup>

            </div >
        );
    });;

    useEffect(() => {
        // console.log(expandedSwitches)
        tickboxFunc(expandedSwitches)
    }, [expandedSwitches]);

    return (
        <Box>
            {renderList}
            {/* <AndroidSwitch labelObj={testObj} icon={JedoxIcon}/> */}
        </Box>
    );
}

export default UpdateUsersAccess;